import React, { useState } from "react";
import { Link } from "react-router-dom";
import Admissionleft from "./Admissoinleft";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import Fade from "react-bootstrap/Fade";

function MtechSelfSponsored_admissionEle() {
    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    // const [categoryOpen, setCategoryOpen] = useState(false);
    const [areasOpen, setAreasOpen] = useState(false);
    const [eligiblityOpen, setEligiblityOpen] = useState(false);
    const [financialOpen, setFinancialOpen] = useState(false);
    // const [sectionOpen, setSectionOpen] = useState(false);
    const [documentsOpen, setDocumentsOpen] = useState(false);
    const [feesOpen, setFeesOpen] = useState(false);
    const [applyonlineOpen, setApplyonlineOpen] = useState(false);

    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);
        // setCategoryOpen(false);
        setAreasOpen(false);
        setEligiblityOpen(false);
        setFinancialOpen(false);
        // setSectionOpen(false);
        setDocumentsOpen(false);
        setFeesOpen(false);
        setApplyonlineOpen(false);
        event(true);
    };

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className="c-left custom-padding-color mb-5">
                        <Admissionleft activeIndex={9} />
                    </Col>

                    <Col md={8} className="c-right">
                        <div className="c-heading">
                            <h3>Master of Technology Self-Sponsored</h3> <br />
                        </div>

                        <Row className="mb-5">
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button"
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}
                                >
                                    Dates
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setGuidelinesOpen)
                                    }
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}
                                >
                                    Guidelines
                                </Button>
                            </Col>

                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setCategoryOpen)}
                                    aria-controls="c-categoryOpen"
                                    aria-expanded={categoryOpen}
                                >
                                    Categories
                                </Button>
                            </Col> */}

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setAreasOpen)}
                                    aria-controls="c-areas"
                                    aria-expanded={areasOpen}
                                >
                                    Areas
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setEligiblityOpen)
                                    }
                                    aria-controls="c-eligiblity"
                                    aria-expanded={eligiblityOpen}
                                >
                                    Eligiblity
                                </Button>
                            </Col>

                            {/* financial */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setFinancialOpen)
                                    }
                                    aria-controls="c-financial"
                                    aria-expanded={financialOpen}
                                >
                                    Financial Assistance
                                </Button>
                            </Col>
                            {/* section */}
                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setSectionOpen)}
                                    aria-controls="c-fiancial"
                                    aria-expanded={sectionOpen}
                                >
                                    Selection
                                </Button>
                            </Col> */}
                            {/* Documents */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setDocumentsOpen)
                                    }
                                    aria-controls="c-document"
                                    aria-expanded={documentsOpen}
                                >
                                    Documents
                                </Button>
                            </Col>

                            {/* Fees */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setFeesOpen)}
                                    aria-controls="c-feesopen"
                                    aria-expanded={feesOpen}
                                >
                                    Fees
                                </Button>
                            </Col>

                            {/* Apply Online */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setApplyonlineOpen)
                                    }
                                    aria-controls="c-applyonline"
                                    aria-expanded={feesOpen}
                                >
                                    Apply Online
                                </Button>
                            </Col>
                        </Row>

                        {/*dates */}
                        <div>
                            {datesOpen && (
                                <Fade in={datesOpen}>
                                    <div>
                                        <p className="fw-bold caboutus"><span className="glowing-text">List of candidates selected for admission to the M.Tech self sponsored programme of Data Science and Artificial Intelligence in the Department of Computer Science and Engineering for the Academic Year 2026-27 - <Link className="c-link" to="https://files.iittp.ac.in/2026/admission/DSAI_Selected Candidates.pdf" target='_blank'>Click here</Link></span></p>
                                        <p className="fw-bold caboutus"><span className="glowing-text">List of candidates selected for admission to the M.Tech self sponsored programme in the Department of Chemical Engineering for the Academic Year 2026-27 - <Link className="c-link" to="https://files.iittp.ac.in/2026/admission/CH_Self_Sponsored_Selected_Candidates.pdf" target='_blank'>Click here</Link></span></p>
                                        <p className="fw-bold caboutus"><span className="glowing-text">Provisionally shortlisted candidates for Written Test of M.Tech - Data Science and Artificial Intelligence(DSAI) (Self-Sponsored) - <Link className="c-link" to="https://files.iittp.ac.in/pdfs/mtech/2026/M_Tech_DSAI_Shortlisted.pdf" target='_blank'>Click here</Link></span></p>
                                        <p className="fw-bold caboutus"><span className="glowing-text">Provisionally shortlisted candidates for Written Test of M.Tech - Chemical Engineering (Self-Sponsored) - <Link className="c-link" to="https://files.iittp.ac.in/pdfs/mtech/2026/M_Tech_CHE_Selected.pdf" target='_blank'>Click here</Link></span></p>
                                        <p className="fw-bold caboutus"><span className="glowing-text">Syllabus for Written test of M.Tech - Chemical Engineering (Self-Sponsored) - <Link className="c-link" to="https://files.iittp.ac.in/pdfs/mtech/2026/M_Tech_CHE_Syllabus.pdf" target='_blank'>Click here</Link></span></p>
                                        <p className="fw-bold caboutus"><span className="glowing-text">Syllabus for Written test and Interview of M.Tech - Data Science and Artificial Intelligence (Self-Sponsored) - <Link className="c-link" to="https://files.iittp.ac.in/pdfs/mtech/2026/M_Tech_DSAL_CSE_Syllabus.pdf" target='_blank'>Click here</Link></span></p>
                                    {/* <p className="fw-bold caboutus"><span className="glowing-text">Selected Candidates List for M.Tech - Data Science and Artificial Intelligence (Self-Sponsored) - <Link className="c-link" to="https://files.iittp.ac.in/pdfs/mtech/2025/M_Tech_DSAL_CSE_Selected_List.pdf" target='_blank'>Click here</Link></span></p>
                                     */}

                                    {/* <p className="fw-bold"> <span className="glowing-text">Orientation Program for M.Tech on July 26, 2024 - {" "}
                                    <Link to={"https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_Mtech_Msc_MPP_2024.pdf"} target="_blank;" className="c-link"> Click here </Link></span> </p>

                                         <img src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="30" height="20" /> 
                                         <a className='text-maroon' href="https://files.iittp.ac.in/pdfs/msphd/admissions/2024/IITTP_2024-25_M.TechSponsored.pdf" target="_blank;"><b>Selected Candidates List for M.Tech program under the Sponsored Category - Click here</b></a>  */}

                                        {/* <p className="fw-bold caboutus"> <span className="glowing-text"> M.Tech Self-Sponsored Programme Flyer 2026 - {" "}
                                    <Link to={"#"} target="_blank;" className="c-link"> Click here </Link> </span></p> */}

                                    {/* <p className="fw-bold caboutus"> M.Tech Self Sponsored Programme Flyer 2026 - {" "}
                                    <Link to={"https://files.iittp.ac.in/pdfs/mtech/2025/M_Tech_DSAI_Self_Sponsored_Flyer.pdf"} target="_blank;" className="c-link"> Click here </Link> </p> */}

                                    <p className="fw-bold caboutus">
                                        
                                        M.Tech Self Sponsored Programme Flyer 2026 - {" "} 
                                    <Link to={"https://files.iittp.ac.in/pdfs/mtech/2026/M.Tech.Self-Sponsored_Flyer.pdf"} target="_blank;" className="c-link"> Click here </Link> 
                                    <img className='ms-1' src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="36" height="20" />
                                    </p>

                                        <Table
                                            bordered
                                            responsive
                                            className="mt-3"
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan="2"
                                                        className="text-center"
                                                    >
                                                        <h4 className="text-primary">
                                                            Important Dates
                                                        </h4>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        Opening date and time for online
                                                        application
                                                    </td>
                                                    <td>15th May 2026 at 5:00 PM</td>
                                                    {/* <td>
                                                        <b>Wednesday, March 20, 2024 at 10 AM</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Closing date and time for online
                                                        application
                                                    </td>
                                                    <td>8th June 2026 up to 5:00 PM </td>
                                                    
                                                    {/* <td>
                                                        <b>	Friday, April 19, 2024 upto 5 PM</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>Written Test</td>
                                                    <td>Chemical Eng. – 02 July 2026 (In Person) (Only written test) <br></br> DSAI – 04 July 2026 (Physical Mode) </td>
                                                    {/* <td>
                                                        <b>12th July 2025</b> {" "}
                                            <Link
                                                to=""
                                                className="c-link"
                                            >
                                                (Written test will be conducted in online mode)
                                            </Link>{" "}
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>Interviews</td>
                                                    <td>DSAI – 05 July 2026 (Physical Mode) </td>
                                                    {/* <td>
                                                        <b>15th, 16th July 2025</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>Announcement of Results</td>
                                                    <td>CH<Link className="c-link" to="https://files.iittp.ac.in/2026/admission/CH_Self_Sponsored_Selected_Candidates.pdf" target='_blank'>(Click here)</Link> DSAI <Link className="c-link" to="https://files.iittp.ac.in/2026/admission/DSAI_Selected Candidates.pdf" target='_blank'>(Click here)</Link></td>
                                                    {/* <td>
                                                        <b>23rd July 2025</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>Reporting to campus</td>
                                                    <td>27th July 2026</td>
                                                    {/* <td>
                                                        <b>30th July 2025</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>In-Person Registration cum Document Verification at IIT Tirupati</td>
                                                    <td>29th July 2026 (FN)</td>
                                                    {/* <td>
                                                        <b>30th July 2025</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Date of Orientation Program
                                                    </td>
                                                    <td>30th July 2026 (AN)</td>
                                                    {/* <td>
                                                        <b>31st July 2025</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Commencement of classes
                                                    </td>
                                                    <td>3rd August 2026</td>
                                                    {/* <td>
                                                        <b>31st July 2025</b>
                                                    </td> */}
                                                </tr>
                                                
                                            </tbody>
                                        </Table>

                                        <b>
                                            In case of any queries,  Please write to{" "}
                                            <Link
                                                to="mailto:admissions@iittp.ac.in"
                                                className="c-link"
                                            >
                                                admissions@iittp.ac.in
                                            </Link>{" "}
                                            or call 0877 250 3532 (9.00 AM to 5.30 PM on all working days).
                                        </b>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Guidelines*/}

                        <div>
                            {guidelinesOpen && (
                                <Fade in={guidelinesOpen}>
                                    <div className="c-lineheight2dot5">
                                        <h4 className="mb-3">
                                            Important Guidelines
                                        </h4>
                                        <h5>For Self Sponsored candidates (Non-HTTA)</h5>
                                        <p className="caboutus">Candidates admitted under the self-sponsored (Non-HTTA) category will not get any financial assistance from the Institute and cannot be moved to the HTTA category at a later date.</p>
                                        <ol className="list-group list-group-numbered caboutus"
                                            style={{
                                                textAlign: "justify",
                                                fontSize: "12pt",
                                            }}
                                        >
                                            
                                            <li>
                                                The link to the online application form is available in the Apply Online tab.
                                            </li>

                                           

                                            <li>
                                                {" "}
                                                The application fee per stream is as follows:
                                                <ul className="myulcustarrow caboutus">
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        GEN/EWS/OBC-NCL Male candidates : Rs.400/-{" "}
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        GEN/EWS/OBC-NCL Female candidates : Rs.200/-
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        SC/ST and PwD candidates : Rs.200/-
                                                    </li>
                                                </ul>
                                                <em
                                                    style={{ color: "#2009df" }}
                                                >
                                                    The application fee is non-refundable. Please ensure to save the payment reference number.
                                                </em>
                                            </li>
                                            <li>
                                                {" "}
                                                Please make all files ready with following format and size before going to file upload: 
                                                <ul className="myulcustarrow caboutus">
                                                    <li>
                                                        Passport size Photo
                                                        (jpg, jpeg, png)
                                                    </li>
                                                    <li>
                                                        Signature (format jpg,
                                                        jpeg, png) 
                                                    </li>
                                                    <li>
                                                        10th Certificate (pdf)
                                                        
                                                    </li>
                                                    <li>
                                                        12th / Diploma /
                                                        Equivalent Certificate (pdf)
                                                        
                                                    </li>
                                                    <li>
                                                        Essential Qualifying Degree Certificate (pdf)
                                                    </li>
                                                    <li>
                                                       Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                                    </li>
                                                    <li>
                                                        Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.
                                                    </li>
                                                   
                                                </ul>
                                            </li>
                                            <li>Please visit the institute’s website regularly for important announcements and results.</li>
                                            <li>
                                            In case of any queries, please
                                            write to{" "}
                                            <a className="c-link" href="mailto:admissions@iittp.ac.in">
                                                admissions@iittp.ac.in
                                            </a>{" "}
                                            or call 0877 250 3532 (9.00 AM to
                                            5.30 PM on all working days).
                                        </li>
                                            
                                        </ol>

                                     
                                        

                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Categoies*/}

                        {/* <div>
                            {categoryOpen && (
                                <Fade in={categoryOpen}>
                                    <div className="c-lineheight2dot5">
                                        <h4 className="mb-3">
                                            Ph.D admissions are made under two
                                            categories
                                        </h4>

                                        <li>
                                            1. Regular (Full-time scholars): The
                                            research scholars selected under
                                            regular registration will be
                                            eligible for assistantship through
                                            various schemes (please see
                                            Financial Assistance)
                                        </li>
                                        <li>
                                            External:
                                            <ul className="myulcustarrow">
                                                <li>
                                                    The applicants must be
                                                    regular employees and have
                                                    at least two years of work
                                                    experience.
                                                </li>
                                                <li>
                                                    They must be sponsored by
                                                    and employed in an
                                                    industry/organization/national
                                                    laboratories, having R&D
                                                    facilities and recognized by
                                                    DST or by IIT Tirupati.
                                                </li>
                                                <li>
                                                    Research scholars admitted
                                                    under this category will
                                                    normally carry out part or
                                                    all of their research in the
                                                    parent organization under
                                                    supervision of a faculty
                                                    from IIT Tirupati and a
                                                    co-supervisor employed in
                                                    their parent organization.
                                                </li>
                                            </ul>
                                        </li>

                                        <ul className="myulcustarrow">
                                            <li>
                                                The following documents are
                                                required along with the
                                                application{" "}
                                            </li>
                                        </ul>

                                        <ol className="myulcustdisc">
                                            <li>
                                                Proof of employment (Identity
                                                Card or latest salary statement)
                                            </li>
                                            <li>
                                                No-Objection Certificate or
                                                Undertaking (format available at
                                                this{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/3.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                                )
                                            </li>
                                        </ol>

                                        <ul className="myulcustarrow">
                                            <li>
                                                The following documents are
                                                required at the time of
                                                admission
                                            </li>
                                        </ul>

                                        <ol className="myulcustdisc">
                                            <li>
                                                Certificate of Support from the
                                                Employer:{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/4.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                            </li>
                                            <li>
                                                Relieving Certificate from the
                                                Employer:{" "}
                                                <Link
                                                    to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/5.docx"
                                                    target="_blank;"
                                                    className="c-link"
                                                >
                                                    Link
                                                </Link>
                                            </li>
                                        </ol>

                                        <ul className="myulcustarrow">
                                            <li>
                                                More details on this category of
                                                admission, including any
                                                questions regarding the
                                                recognition of the
                                                organization/laboratory might be
                                                addressed to the Head of the
                                                department of interest or{" "}
                                                <Link
                                                    to="mailto:admissions@iittp.ac.in"
                                                    className="c-link"
                                                >
                                                    admissions@iittp.ac.in
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </Fade>
                            )}
                        </div> */}

                        {/*Areas*/}

                        <div>
                            {areasOpen && (
                                <Fade in={areasOpen}>
                                    <div>
                                        <h4 className="mb-4">Areas</h4>
                                        <p>
                                        IIT Tirupati offers M.Tech. Self-Sponsored programs in the following area/stream.
                                        </p>

                                        {/* Table */}
                                        <Table
                                            bordered
                                            responsive
                                            className="mt-3 c-table"
                                        >
                                            <colgroup>
                                                {/* <col style={{ width: "20%" }} />{" "} */}
                                                {/* 33% for each column */}
                                                <col style={{ width: "50%" }} />
                                                <col style={{ width: "50%" }} />
                                            </colgroup>
                                            <tbody>
                                                {/* Table header */}
                                                <tr>
                                                    <td>
                                                        <b>Department</b>
                                                    </td>
                                                    <td>
                                                        <b>
                                                            M.Tech. Stream /
                                                            Specialization
                                                        </b>
                                                    </td>
                                                </tr>
                                                

                                                {/* Row 3 */}
                                                <tr>
                                                    <td valign="middle">
                                                        Computer Science &amp;
                                                        Engineering
                                                    </td>
                                                    <td>
                                                        Data Science & Artificial Intelligence
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                    <td valign="middle">
                                                        Chemical Engineering
                                                    </td>
                                                    <td>
                                                        Chemical Engineering
                                                    </td>
                                                    </tr>
                                               

                                                {/* End of table rows */}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Eligiblity*/}

                        <div>
                            {eligiblityOpen && (
                                <Fade in={eligiblityOpen}>
                                    <div>
                                        <h4 className="mb-4">Eligibility</h4>
                                        <p className="caboutus">Candidates seeking admission to the M.Tech. Self-sponsored programmes are required to meet the following criteria:</p>

                                        

                                        <ul className='myulcustarrow caboutus'>
                                            <li>
                                                Bachelor’s degree in Engineering/ Technology/4-year BS degree or Master’s Degree in a suitable discipline as in the below table (Table A), through regular/distance education/correspondence mode/online mode, from Educational Institutions approved by AICTE / Government. 
                                            </li>
                                            <li>
                                                Candidates yet to appear or have appeared in the final examination for the qualifying degree as specified below, and who are likely to complete the requirements for the qualifying degree by July, 2026.
                                            </li>
                                            
                                            <li>GATE or any other National Level Examination is not required for eligibility.</li>
                                        </ul>< br />
                                            <h5 className="mb-4 text-center">Table-A</h5>
                                       <Table
                                            bordered
                                            responsive
                                            className="mt-3"
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan="3"
                                                        className="text-center"
                                                    >
                                                        <h5>
                                                            Eligibility to apply for M. Tech. Self-Sponsored Programme - 2026
                                                        </h5>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="2"
                                                       
                                                        className="text-center"
                                                    >
                                                        <h5>
                                                            A candidate is eligible to apply
                                                        </h5>
                                                    </th>
                                                    <th
                                                       
                                                        className="text-center"
                                                    >
                                                        <h5>
                                                            
                                                        </h5>
                                                    </th>
                                                </tr>
                                                
                                                <tr>
                                                    <th
                                                        
                                                        className="text-center"
                                                    >
                                                        <h5>
                                                           Department
                                                        </h5>
                                                    </th>
                                                    <th
                                                        
                                                        className="text-center"
                                                    >
                                                        <h5>
                                                           Stream
                                                        </h5>
                                                    </th>
                                                    <th
                                                        
                                                        className="text-center"
                                                    >
                                                        <h5>
                                                           If the candidate has
                                                        </h5>
                                                    </th>
                                                </tr>
                                                
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        Computer Science & Engineering
                                                    </td>
                                                    <td>
                                                        Data Science & Artificial Intelligence
                                                    </td>
                                                    <td>B.E/ B.Tech/M.Sc/MCA/MS degree in any discipline</td>
                                                </tr>
                                                
                                                
                                                <tr>
                                                    <td>Chemical Engineering</td>
                                                    <td>Chemical Engineering</td>
                                                    <td>B.Tech/BE/M.Sc in any discipline
                                                    </td> 
                                                    
                                                </tr>
                                                
                                               
                                                
                                            </tbody>
                                        </Table>
                                       
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Fiancial  Assistance*/}

                        <div>
                            {financialOpen && (
                                <Fade in={financialOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Financial Assistance and Other Conditions
                                        </h4>
                                         <ul className='myulcustarrow caboutus'>
                                            <li>
                                            Candidates admitted under the Self-sponsored category will not be eligible for Half-Time Teaching Assistantship (HTTA) or any other financial assistance from the Institute.
                                            </li>
                                            <li>
                                            Candidates admitted under the Self-sponsored category will not be eligible for upgradation to the Ph.D. program. However, they may apply for Ph.D. admission as fresh applicants through the regular admission process, upon successful completion of the M.Tech. program.
                                            </li>
                                            
                                        </ul>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Section*/}

                        {/* <div>
                            {sectionOpen && (
                                <Fade in={sectionOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Selection Procedure
                                        </h4>
                                        <p>
                                            The selection committee will call
                                            eligible candidates based on the
                                            minimum eligibility requirements and
                                            additional screening criteria for a
                                            written test (if any) and interview.
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div> */}

                        {/*Documents*/}

                        <div>
                            {documentsOpen && (
                                <Fade in={documentsOpen}>
                                    <div>
                                    <h3 className="mb-4"> Original Documents to be submitted for Verification:</h3>
                                        
                                        <p>
                                            <b>At the time of admission:</b>
                                        </p>
                                       

                                        <ul className="myulcustarrow caboutus">
                                            <li>Offer of admission.</li>
                                            <li>10th Certificate</li>
                                            <li>12th / Diploma / Equivalent Certificate</li>
                                            <li>Essential Qualifying Degree Certificate</li>
                                            <li>Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.</li>
                                            <li>Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.</li>
                                        </ul>
                                        <h5 className="text-teal">
                                        Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
                                        </h5>


                                        

                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Section*/}

                        <div>
                            {feesOpen && (
                                <Fade in={feesOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Fees and Deposits
                                        </h4>
                                        <p className="caboutus">
                                        The applicable tuition and other fee/deposits for M.Tech. Self-sponsored students are available on the Institute website:
                                            <Link
                                                to="/fee-structure"
                                                className="c-link"
                                            >link
                                            </Link>
                                            .
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div>
                        {/*Apply Online*/}

                        <div>
                            {applyonlineOpen && (
                                <Fade in={applyonlineOpen}>
                                    <div>
                                        <h5 className="mb-4">To apply for Data Science & Artificial Intelligence : 
                                      

                                            <Link
                                                to="https://docs.google.com/forms/d/e/1FAIpQLSeuAmyGoo1i-Q2XHRJKvjGc7LeRYUeJ6YvNQRf5Ut0ekCYS7g/viewform?usp=header"
                                                target="_blank"
                                                className="c-link">
                                                <b className="text-maroon">Click here</b>
                                            </Link>

                                        </h5>
                                        <h5 className="mb-4">To apply for Chemical Engineering : 
                                      

                                            <Link
                                                to="https://docs.google.com/forms/d/e/1FAIpQLSc4y8TTcHbPjlwelOUzCgb1wb2z6UJ-xm-9jiBIJOoDFk3OPw/viewform?usp=publish-editor"
                                                target="_blank"
                                                className="c-link">
                                                <b className="text-maroon">Click here</b>
                                            </Link>

                                        </h5>

                                        <ol className="list-group list-group-numbered caboutus"
                                            style={{
                                                textAlign: "justify",
                                                fontSize: "12pt",
                                            }}
                                        >
                                            
                                            <li>
                                                {" "}
                                               <b> The application fee per stream is as follows:</b>
                                                <ul className="myulcustarrow caboutus">
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        GEN/EWS/OBC-NCL Male candidates : Rs.400/-{" "}
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        GEN/EWS/OBC-NCL Female candidates : Rs.200/-
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        SC/ST and PwD candidates : Rs.200/-
                                                    </li>
                                                </ul>
                                               
                                            </li>
                                            <li class="aboutus"><b>The application fees should be paid to the Institute account:  </b>
                                            <ul className="myulcustarrow caboutus">
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        Branch Name: SBI IIT Campus Tirupati{" "}
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        Name: Indian Institute of Technology Tirupati
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        Account Number: 41139652035
                                                    </li>
                                                    <li>
                                                        <i
                                                            className="fa fa-arrow-circle-o-right"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        IFSC Code: SBIN0064604
                                                    </li>
                                                </ul>
                                            
                                             <em
                                                    style={{ color: "#2009df" }}
                                                >
                                                    The application fee is non-refundable. Please ensure to save the payment reference number.
                                                </em>
                                            
                                            </li>
                                            
                                            
                                            
                                            </ol>

                                        {/* <h5 className="mb-4"> Apply Online :


                                            <Link to="#"  target="_self" className="c-link">
                                                <b className="text-maroon">Will be updated soon..</b>
                                            </Link>

                                        </h5>  */}

                                        {/* <h5 className="mb-4">For Sponsored (Non-HTTA candidates)  :


                                        <Link to="#"  className="c-link">
                                                <b className="text-maroon">Online applications are now closed.</b>
                                            </Link>

                                        </h5>  */}

                                        

                                    
                                    </div>
                                </Fade>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default MtechSelfSponsored_admissionEle;
